import { render } from "./AboutUsHomePage.vue?vue&type=template&id=7f75b82c"
import script from "./AboutUsHomePage.vue?vue&type=script&lang=js"
export * from "./AboutUsHomePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__